import { render, staticRenderFns } from "./CustomerComment.vue?vue&type=template&id=61f2eea4&scoped=true"
import script from "./CustomerComment.vue?vue&type=script&lang=js"
export * from "./CustomerComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f2eea4",
  null
  
)

export default component.exports